import { translate } from "../../core/i18n"
import { RoundButton } from "../buttons/base/RoundButton"

export const SupportChatSwitch = (props) => {
  const title = translate("support-button-title");
  return <RoundButton className="support-btn" icon="wand-magic-sparkles" onClick={props.switch} title={title} iconColor="#000000" borderColor='#1cbaba' backgroundColor='#6ae5e5' />;
}